import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { AddEditApi } from '../interfaces/template.interface';
import queryString from 'query-string';

const list = (payload: any) => {
  let query = queryString.stringify(payload);
  return http.get(`${API_ENDPOINTS.listTemplates}?${query}`);
};

const add = (payload: AddEditApi) => {
  return http.post(API_ENDPOINTS.addTemplate, payload);
};

const edit = (id: string, payload: AddEditApi) => {
  return http.put(`${API_ENDPOINTS.editTemplate}/${id}`, payload);
};

const get = (id: string) => {
  return http.get(`${API_ENDPOINTS.getTemplate}/${id}`);
};

const getTemplateHeaderLookup = () => {
  return http.get(API_ENDPOINTS.listTemplateHeaders);
};

const getTemplateHeaders = (templateId: string) => {
  return http.get(`${API_ENDPOINTS.getTemplateHeaders}/${templateId}`);
};

const saveTemplateHeaders = (templateId: string, payload: any) => {
  return http.put(`${API_ENDPOINTS.getTemplateHeaders}/${templateId}`, payload);
}
const lookup = (payload: { searchText?: string }) => {
  const url = `${API_ENDPOINTS.lookupTemplates}?${queryString.stringify({ search: payload.searchText || '' })}`;
  return http.get(url);
};

const TemplateService = {
  list,
  add,
  edit,
  get,
  getTemplateHeaderLookup,
  getTemplateHeaders,
  saveTemplateHeaders,
  lookup,
};

export default TemplateService;
